import { star } from '../../assets/icons';
import { defaultLettersCircle } from '../../helpers/helper';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ar';
import 'dayjs/locale/en';
import { useTranslation } from 'react-i18next';

const getChatStatusString = (statusNumber) => {
  const statusMap = {
    1: 'chats.open',
    2: 'chats.closed',
    3: 'chats.complete'
  };
  return statusMap[statusNumber] || 'chats.unknown';
};

dayjs.extend(relativeTime);

const CarOwnerCardUser = ({
  selected = false,
  receivedMessage = false,
  onClick,
  user,
}) => {
  const { t, i18n } = useTranslation();
  
  return (
    <div
      className={`${
        receivedMessage
          ? 'bg-red hover:bg-gray-50'
          : selected
            ? 'bg-[#00CEBC] hover:bg-[#00b5a7] text-white'
            : 'bg-white hover:bg-gray-50'
      } rounded-[16px] m-2 shadow-sm border border-gray-100 cursor-pointer transition-all duration-200 transform hover:scale-[1.01] p-4`}
      onClick={onClick}
    >
      <div className="flex justify-between items-start gap-4">
        <div className="flex items-start gap-4">
          <div className="relative flex-shrink-0">
            {!user?.receiverInfo?.profileImg ? (
              <div className="w-[60px] h-[60px] rounded-full shadow-lg border-2 border-white flex items-center justify-center bg-gradient-to-r from-[#00CEBC] to-[#3E0292] text-white text-xl font-semibold">
                {defaultLettersCircle(user.receiverInfo?.fullName || '', 'w-[60px]', 'h-[60px]')}
              </div>
            ) : (
              <img
                src={user.receiverInfo?.profileImg}
                alt={user.receiverInfo?.fullName}
                className="w-[60px] h-[60px] rounded-full object-cover border-2 border-white shadow-lg"
              />
            )}
            {user.chatStatus && (
              <div className="absolute bottom-0 right-0 w-4 h-4 rounded-full bg-green-500 border-2 border-white"></div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-[16px] font-semibold text-gray-900 truncate">
                {user.receiverInfo?.fullName}
              </h3>
              {user.receiverInfo?.medAvgRating && (
                <div className="flex items-center gap-1 bg-gray-50 px-2 py-1 rounded-full">
                  <img src={star} alt="Rating" className="w-4 h-4" />
                  <span className="text-sm text-gray-600">
                    {user.receiverInfo?.medAvgRating}
                  </span>
                </div>
              )}
            </div>
            {/* <p className="text-sm text-gray-600 line-clamp-2 mb-3">
              {user.lastMessage || t('chats.no_messages')}
            </p> */}
            
            <div className="flex items-center gap-4 w-[100%]">
              <div className="flex items-center gap-2">
                <span className={`text-xs ${selected ? 'text-white' : 'text-gray-500'}`}>{t('chats.offerId')}:</span>
                <span className={`text-sm font-medium ${selected ? 'text-white' : 'text-[#00CEBC]'}`}>#{user.medOfferId}</span>
              </div>
              <div className="flex items-center gap-2 mt-3">
                <span className={`text-xs ${selected ? 'text-white' : 'text-gray-500'}`}>{t('chats.smId')}:</span>
                <span className={`text-sm font-medium ${selected ? 'text-white' : 'text-[#00CEBC]'}`}>#{user.smId}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col items-end gap-3">
          <div className={`rounded-lg p-2 ${selected ? 'bg-[#00b5a7]' : 'bg-gray-50'}`}>
            <div className="flex items-center gap-2">
              <span className={`text-xs ${selected ? 'text-white' : 'text-gray-500'}`}>{t('chats.chatStatus')}:</span>
              <span className={`text-sm font-medium ${selected ? 'text-white' : 'text-[#00CEBC]'}`}>
                {t(getChatStatusString(user.chatStatus))}
              </span>
            </div>
          </div>
          
          {receivedMessage && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#00CEBC] text-white">
              {t('unread_messages', { count: 2 })}
            </span>
          )}
          
          <div className={`text-xs ${selected ? 'text-white' : 'text-gray-500'}`}>
            {user.lastMessageTime &&
              dayjs(user.lastMessageTime)
                .locale(['ar', 'en'].includes(i18n.language) ? i18n.language : 'en')
                .format(
                  ['ar', 'en'].includes(i18n.language) && i18n.language === 'ar'
                    ? 'YYYY/MM/DD hh:mm:ss a'
                    : 'DD-MM-YYYY hh:mm:ss a'
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarOwnerCardUser;
